import OptimizedImage from "./OptimizedImage";

export default function BlogSection() {
  return (
    <section className="home-section">
      <div className="heading">
        <OptimizedImage
          src={require("../assets/images/blog-icon.png")}
          className="icon"
          alt="Icona Blog"
          width={64}
          height={64}
          loading="lazy"
        />
        <div style={{ fontWeight: "bold", color: "#145444" }}>Blog</div>
      </div>
      <div className="divider" />
    </section>
  );
}
